import map from "lodash/fp/map";
import moment from "moment";
import constants from "../../core/constants";

class CreditsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Count", name: "count", isSortable: true },
      { title: "Uploaded By", name: "createdBy" },
      { title: "Uploaded At", name: "createdAt" },
      { title: "Amount", name: "amount" },
      { title: "City", name: "city" },
    ];

    this.filters = [
      {
        name: "name",
        title: "Campaign Name",
        icon: "featured_play_list",
        resource: "Credits",
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item = Object.assign({}, item._source, { _id: item._id });
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.amount /= constants.currencyBy;
      item.amount += " EGP";

      return item;
    };
    return map(format)(data);
  }
}

export default CreditsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/credits/credits.transforms.js